import { Navigate, createBrowserRouter } from 'react-router-dom';
import NotFound from './views/NotFound';
import GestLayout from './components/GestLayout';
import DefaultLayout from './components/DefaultLayout';
import AllBroadcasts from './views/broadcasts/AllBroadcasts';
import AllConfirmations from './views/confirmations/AllConfirmations';
import Login from './views/auth/Login';
import SignUp from './views/auth/Signup';
import NewBroadcast from './views/broadcasts/new/NewBroadcast';
import NewMessage from './views/messages/NewMessage';
import SuccessPayment from './views/payment/SuccessPayment';
import CancelPayment from './views/payment/CancelPayment';
import DynamicContent from './views/DynamicContent';
import Home from './views/home/Home';

const router = createBrowserRouter([
    {
        path: '/',
        element: <Home />,
    },
    {
        path: '/',
        element: <DefaultLayout />,
        children: [
            {
                path: '/new-message',
                element: <NewMessage />,
            },
            {
                path: '/new-broadcast',
                element: <NewBroadcast />,
            },
            {
                path: '/all-broadcasts',
                element: <AllBroadcasts />,
            },
            {
                path: '/success-payment',
                element: <SuccessPayment />,
            },
            {
                path: '/cancel-payment',
                element: <CancelPayment />,
            },
            {
                path: '/all-confimations',
                element: <AllConfirmations />,
            },
            {
                path: '/:slug',
                element: <DynamicContent />,
            },
            {
                path: '*',
                element: <NotFound />,
            },
        ],
    },
    {
        path: '/',
        element: <GestLayout />,
        children: [
            {
                path: '/',
                element: <Navigate to="/login" />,
            },
            {
                path: '/login',
                element: <Login />,
            },
            {
                path: '/signup',
                element: <SignUp />,
            },
            {
                path: '/:slug',
                element: <DynamicContent />,
            },
            {
                path: '*',
                element: <NotFound />,
            },
        ],
    },
    {
        path: '/:slug',
        children: [
            {
                path: '/:slug',
                element: <DynamicContent />,
            },
            {
                path: '*',
                element: <NotFound />,
            },
        ],
    },
]);

export default router;
